import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { useAppSelector } from '../../hooks';
import { TUser, TUserResponse, adaptUserFromResponse } from '../../types';
import { BACKEND_ADMIN_USERS } from '../../backend-paths';


export const userPasswordReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_USERS}/:nickname/password`,
	(payload: string, thunkApi) => {
		const path = `${BACKEND_ADMIN_USERS}/${payload}`;

		return HttpService.get<TUserResponse>(path).then(result => {
			return adaptUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	data: TUser | undefined,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	data: undefined,
	isLoading: false,
	error: undefined,
};

export const userPasswordReadSlice = createSlice({
	name: 'userPasswordReadSlice',
	initialState,
	reducers: {
		setUserPasswordRead(state, action: PayloadAction<TUser>) {
			state.data = action.payload;
		},

		clearUserPasswordRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userPasswordReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userPasswordReadGetApi.fulfilled.type]: (state, action: PayloadAction<TUser>) => {
			state.isLoading = false;
			state.data = action.payload;
		},

		[userPasswordReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserPasswordReadSelector = () => useAppSelector(state => state[userPasswordReadSlice.name]);

export const { clearUserPasswordRead, setUserPasswordRead } = userPasswordReadSlice.actions;
